import { IPostalCodeCoordinates } from '@packlink/packlink-sdk';
import LocationsGeoCoder from './LocationsGeoCoder';

interface ISellerLocation {
    getSellerLocation: (
        address: string | undefined,
        postalCode: string,
        city: string,
    ) => Promise<IPostalCodeCoordinates>;
}

export const sellerLocationGeoCoderFactory = (locationsGeocoder: LocationsGeoCoder): ISellerLocation => {
    return {
        getSellerLocation: (
            address: string | undefined,
            postalCode: string,
            city: string,
        ): Promise<IPostalCodeCoordinates> =>
            locationsGeocoder
                .getLatitudeAndLongitudeFor(address, postalCode)
                .catch(() => locationsGeocoder.getPostalCode(postalCode, city)),
    };
};
